import {RootState} from 'store'

type StateType = RootState

/**
 * Returns the `getSearchProgressPercentage` value from the `progressBar` slice of state
 */
export const getSearchProgressPercentage = (state: StateType) =>
  state.progressBar.searchProgressPercentage
